module.exports = __webpack_public_path__ + "static/sustainable_img2@2x-49f9346e131bdc5515251775cda069cc.jpg";